import React, { useCallback } from 'react';
import cx from 'classnames';
import Icon from '../../Icon';
import { useSegmentedController } from '../context';
import styles from './SegmentedControllerItem.module.scss';
const SegmentedControllerItem = ({ className, value, children, icon, disabled = false, iconPosition = 'left', }) => {
    const { selectedValue, handleValueChange, size } = useSegmentedController();
    const isSelected = selectedValue === value;
    const handleClick = useCallback(() => {
        if (!disabled && selectedValue !== value) {
            handleValueChange(value);
        }
    }, [disabled, value, selectedValue, handleValueChange]);
    return (React.createElement("button", { type: "button", className: cx(styles.item, className, {
            [styles.selected]: isSelected,
            [styles.disabled]: disabled,
            [styles[`size-${size}`]]: !!size,
            [styles[`icon-position-${iconPosition}`]]: !!icon,
        }), onClick: handleClick, disabled: disabled, "aria-pressed": isSelected },
        icon && (React.createElement(Icon, { name: icon, size: size === 'small' ? 'md' : 'lg', className: styles.icon })),
        children));
};
export default SegmentedControllerItem;
